import {Component, OnInit, Input, Output, EventEmitter, ElementRef} from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import { AuthHttp, AuthConfig } from 'angular2-jwt';
import { SharedService } from '../shared/shared.service';
import * as Materialize from 'angular2-materialize';

/// <reference path="./dropzone.d.ts"/>
declare var AWS: any;
@Component({
  selector: 'dropzoneattach',
  template: `<div id="previews2" class="dropzone needsclick dz-clickable dz-started"><div id="dropzoneattachback" class="dropzone-attach-customback"></div></div>`
})
export class DropzoneAttachComponent implements OnInit {

  private _dropzone: Dropzone;
 _service: any;
  @Input()
  element: string = '.dropzoneArea';

  @Input()
  url: string = 'file/post';

  @Input()
  uploadMultiple: boolean = false;

  @Input()
  maxFileSize: number = 25;

  @Input()
  clickable: string = '.dropzoneArea';

  @Input()
  autoProcessQueue: boolean = true;

  @Input()
  addRemoveLinks: boolean = true;

  @Input()
  createImageThumbnails: boolean = true;

  @Input()
  previewTemplate: string = '<div class="dz-preview dz-file-preview"><div class="dz-details"><div class="dz-filename"><span data-dz-name></span></div><div class="dz-size" data-dz-size></div><img data-dz-thumbnail /></div><div class="dz-success-mark"><span>?</span></div><div class="dz-error-mark"><span>?</span></div></div>';

  @Input()
  acceptedFiles: string = '*';

  @Output()
  sending: EventEmitter<boolean>;

  @Output()
  uploadprogress: EventEmitter<number>;

  @Output()
  success: EventEmitter<any>;

  @Output()
  error: EventEmitter<any>;

  @Output()
  fileRemoved: EventEmitter<any>;

  @Output()
  fileadded: EventEmitter<any>;

  @Output()
  dropzoneEmpty: EventEmitter<any>;

  constructor(private _eleRef: ElementRef, private _http: Http, private service: SharedService, private http: Http,
                 public authHttp: AuthHttp){

      this.sending = new EventEmitter<boolean>();
      this.uploadprogress = new EventEmitter<number>();
      this.success = new EventEmitter<any>();
      this.error = new EventEmitter<any>();
      this._service = service;
      this.fileRemoved = new EventEmitter<any>();
      this.dropzoneEmpty = new EventEmitter<any>();
      this.fileadded = new EventEmitter<any>();
      console.log('SERVICE:', service);
  }

  initDropzone(){

          this._dropzone = new Dropzone('div#previews2', {
              url: this.url,
              uploadMultiple: this.uploadMultiple,
              maxFilesize: this.maxFileSize,
              clickable: true,
              autoProcessQueue: this.autoProcessQueue,
              addRemoveLinks: this.addRemoveLinks,
              createImageThumbnails: this.createImageThumbnails,
              previewTemplate: this.previewTemplate
          });


          this._dropzone.on('sending', (file, xhr, formaData) => {
              this.sending.emit(true);
          });

          this._dropzone.on('uploadprogress', (file, progress, bytesSent) => {
              this.uploadprogress.emit(progress);
          });

          this._dropzone.on('success', (file) => {
              // this.success.emit(file);
          });

          this._dropzone.on('error', (file, message) => {
              // this.error.emit(message);
          });

          this._dropzone.on('addedfile', (file, message) => {
              console.log('Removed file path and name name: ', file.name);
              if (file.size > 25000000)
              {
                let element = document.getElementById('dropzoneattachback');
                element.parentNode.removeChild(element);
                this._dropzone.removeFile(file);
                Materialize.toast('File is too big ' + Math.round(file.size / 1024 / 1024) + 'MB. Max filesize for attachments: 25MB.', 4000);
                return;
              }
              if (this._dropzone.files.length > 0)
              {
                if (this._dropzone.files.length === 1)
                {
                    let element = document.getElementById('dropzoneattachback');
                    element.parentNode.removeChild(element);
                }
                this._service.addFileinAttchmentArray(file);
                this.fileadded.emit({
                    file: file[0]
                  });
              }
          });

          this._dropzone.on('removedfile', (file, message) => {
            // this.deleteFileFromS3BucketIfExist(file);
            this.fileRemoved.emit(file);
            if (this._dropzone.files.length === 0)
            {
              $('#previews2').append('<div id="dropzoneattachback" class="dropzone-attach-customback"></div>');
              this.dropzoneEmpty.emit();
            }
            this._service.removeFilefromAttachmentArray(file);
          });

  }

  ngOnInit(){
      this.initDropzone();
  }

  clearDropzoneAttach(){
    this._dropzone.removeAllFiles();
  }

}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/dropzone/dropzone-attach.component.ts